import Actions from "../actions";
import { produce } from "immer";

const initialState = {
    superAdminSubscription : {}
};


const superAdminSubscription = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {

    case Actions.GET_SUPER_ADMIN_SUBSCRIPTION_LIST: {
      draft.superAdminSubscription = payload?.superAdminSubscription;
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default superAdminSubscription;
